export function getPageOffset(limit: number, page?: number | string) {
  return Number(page) > 0 ? (Number(page) - 1) * limit : 0;
}
